export default __webpack_public_path__ + "img/Poppins-Black_8094fe5.ttf";